import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChiliPiperComponent } from './chilipiper-calendar.component';

export const ChiliPiperCalendarExports = [ChiliPiperComponent];
@NgModule({
    imports: [CommonModule],
    declarations: [...ChiliPiperCalendarExports],
    exports: [...ChiliPiperCalendarExports],
    providers: []
})
export class ChiliPiperCalendarModule {}
